
(function() {
  console.log('sendPendingAndClearnew');
  const PENDING_ANALYTICS_KEY = 'produktberater_pending_analytics';
  function sendPendingAndClear() {
    try {
      const raw = sessionStorage.getItem(PENDING_ANALYTICS_KEY);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data || !data.payload) {
        sessionStorage.removeItem(PENDING_ANALYTICS_KEY);
        return;
      }
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('fritzbox_finder_step', data.payload);
        console.warn('sendPendingAndClear', data.payload);
      }
      sessionStorage.removeItem(PENDING_ANALYTICS_KEY);
    } catch (e) {
      sessionStorage.removeItem(PENDING_ANALYTICS_KEY);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sendPendingAndClear);
  } else {
    sendPendingAndClear();
  }
})();